<app-loader *ngIf="isLoading"></app-loader>

<app-on-display [campaign_id]="campaignId" (close_campaign)="exitNoQuestion()" [last_click]="lastClick"></app-on-display>

<div class="container mt-2 header-container">
	<div class="d-flex justify-content-between align-items-baseline mb-3 header-bar">
		<div class="d-flex align-items-baseline gap-2">
			<button class="btn-exit" ngbTooltip="Exit" (click)="onExit()">
				<i class="ri-arrow-left-line"></i>
			</button>
			<h3 class="mb-0">{{ campaignName }} - {{ campaignAlias }}</h3>
		</div>
		<div class="d-flex align-items-baseline gap-2 phone-actions">
			<a *ngIf="contactForm.get('primaryPhone')?.value" [href]="'tel:' + contactForm.get('primaryPhone')?.value" class="phone-link" (click)="onPrimaryPhoneClick()">
				{{ formatPhone(contactForm.get("primaryPhone")?.value) }}
			</a>
			<button class="btn-back" ngbTooltip="Dispo" (click)="onDispo()">Dispo</button>
		</div>
	</div>
</div>

<div class="container">
	<nav class="nav-border-top nav-justified">
		<ul class="nav nav-tabs-custom w-100">
			<li class="nav-item">
				<a class="nav-link" (click)="changeTab('prospects')" [class.active]="showCalendar === 'prospects'" style="cursor: pointer">PROSPECTS</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changeTab('callsheet')" [class.active]="showCalendar === 'callsheet'" style="cursor: pointer">CALL SHEET</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changeTab('leads')" [class.active]="showCalendar === 'leads'" style="cursor: pointer">LEADS</a>
			</li>
		</ul>
	</nav>
</div>

<div class="container mt-2" *ngIf="showCalendar === 'prospects'">
	<h3>📞{{ contactForm.get("companyName")?.value || "Sin nombre" }}</h3>
	<div class="container">
		<nav class="nav-pills">
			<ul class="nav nav-tabs nav-custom-tabs">
				<li class="nav-item">
					<a class="nav-link" [class.active]="!DetailsTab" (click)="DetailsTab = false" style="cursor: pointer"> Basic </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" [class.active]="DetailsTab" (click)="DetailsTab = true" style="cursor: pointer"> Details </a>
				</li>
			</ul>
		</nav>
	</div>

	<form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
		<!--PROSPECT INFO-->
		<div class="form-section" *ngIf="!DetailsTab">
			<div class="row">
				<div class="col-md-10">
					<label>Company Name</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-building-4-fill"></i>
						</span>
						<input class="form-control" formControlName="companyName" placeholder="Company Name" />
					</div>
				</div>
				<div class="col-md-2">
					<label>Primary Phone</label>
					<a *ngIf="contactForm.get('primaryPhone')?.value" [href]="'tel:' + contactForm.get('primaryPhone')?.value" style="color: #0d68c3; text-decoration: underline; font-size: 1.2rem" (click)="onPrimaryPhoneClick()">
						{{ formatPhone(contactForm.get("primaryPhone")?.value) }}
					</a>
				</div>
				<div class="col-md-4">
					<label for="title">Title</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-id-card"></i>
						</span>
						<select class="form-control" formControlName="title">
							<option *ngFor="let title of titles" [value]="title">{{ title }}</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<label>First Name</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-user-3-fill"></i>
						</span>
						<input class="form-control" formControlName="firstName" />
					</div>
				</div>
				<div class="col-md-4">
					<label>Last Name</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-user-3-fill"></i>
						</span>
						<input class="form-control" formControlName="lastName" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Alt Phone</label>
					<div class="input-group">
						<input type="text" class="form-control" [value]="altPhoneDisplay" [ngClass]="{ 'text-muted': !altPhone }" readonly />

						<a *ngIf="altPhone" class="input-group-text" [href]="'tel:' + altPhone" (click)="onPhoneClick(altPhone)"> 📞 </a>
					</div>
				</div>
				<div class="col-md-3">
					<label>Prospect Time</label>

					<input type="text" class="form-control" [value]="prospectTimeDisplay" [ngClass]="{ 'text-muted': !prospectTime }" readonly />
				</div>
				<div class="col-md-3">
					<label>Address 1</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-send-plane-fill"></i>
						</span>
						<input class="form-control" formControlName="address1" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Address 2</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-send-plane-fill"></i>
						</span>
						<input class="form-control" formControlName="address2" />
					</div>
				</div>
				<div class="col-md-3">
					<label>City</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-send-plane-fill"></i>
						</span>
						<input class="form-control" formControlName="city" />
					</div>
				</div>
				<div class="col-md-3">
					<label>EIN</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bx-id-card"></i>
						</span>
						<input class="form-control" formControlName="ein" />
					</div>
				</div>
				<div class="col-md-3">
					<label>State</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-send-plane-fill"></i>
						</span>
						<input class="form-control" formControlName="state" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Zip</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-send-plane-fill"></i>
						</span>
						<input class="form-control" formControlName="zip" />
					</div>
				</div>
				<div class="col-md-4">
					<label>Alt Contact</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-account-circle-fill"></i>
						</span>
						<input class="form-control" formControlName="altContact" />
					</div>
				</div>
				<div class="col-md-4">
					<label>Alt Phone</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-phone"></i>
						</span>
						<input class="form-control" formControlName="altPhone" />
					</div>
				</div>
				<div class="col-md-4">
					<label>5500 Form</label>
					<div class="position-relative">
						<input class="form-control pe-5" formControlName="form5500" placeholder="5500 Form" />
						<button type="button" class="btn btn-sm btn-primary position-absolute top-50 end-0 translate-middle-y" style="right: 0; border-top-left-radius: 0; border-bottom-left-radius: 0" (click)="onEnter5500()">
							<i class="ri-arrow-right-line"></i>
						</button>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<label>Additional Info</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bx-health"></i>
						</span>
						<input class="form-control" formControlName="additionalInfo" />
					</div>
				</div>
			</div>

			<div class="row mt-3">
				<div class="col-12">
					<label>Notes</label>
					<textarea class="form-control bg-success-subtle border-success-subtle text-dark" formControlName="notes"></textarea>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-12">
					<div class="notes-chat">
						<div *ngFor="let note of prospectNotes" class="note-bubble d-flex align-items-start mb-3">
							<img [src]="note.user_avatar || 'https://cdn-icons-png.flaticon.com/512/847/847969.png'" class="avatar-sm rounded-circle me-3 shadow-sm" alt="user" />
							<div class="note-content flex-grow-1">
								<div class="note-header d-flex justify-content-between align-items-center mb-1">
									<h5 class="note-user mb-0">{{ note.user_name }}</h5>
									<small class="note-date text-muted fst-italic">{{ note.created_at | date: "short" }}</small>
								</div>
								<p class="note-text mb-0">{{ note.notes }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--DETAILS TAB-->
		<div class="row" *ngIf="DetailsTab">
			<div class="row">
				<div class="col-md-2">
					<label class="form-label">Direct Line</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-phone"></i>
						</span>
						<input type="text" class="form-control" formControlName="directLine" placeholder="Direct Line" />
					</div>
				</div>
				<div class="col-md-2">
					<label>Mobile Phone</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bx-mobile"></i>
						</span>
						<input type="text" class="form-control" formControlName="mobilePhone" placeholder="Mobile Phone" />
					</div>
				</div>
				<div class="col-md-2">
					<label>Extension</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-phone-call"></i>
						</span>
						<input type="text" class="form-control" formControlName="extension" placeholder="Extension" />
					</div>
				</div>
				<div class="col-md-6">
					<label>Website</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bx-laptop"></i>
						</span>
						<input class="form-control" formControlName="website" placeholder="http://" />
					</div>
				</div>

				<div class="col-md-6">
					<label>Primary Email</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-envelope"></i>
						</span>
						<input class="form-control" formControlName="primaryMail" placeholder="Primary Email" />
					</div>
				</div>
				<div class="col-md-6">
					<label>Alt Email</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="las la-envelope"></i>
						</span>
						<input class="form-control" formControlName="altMail" placeholder="Alt Email" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Employee Size</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-team-fill"></i>
						</span>
						<input class="form-control" formControlName="employeeSize" placeholder="Employee Size" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Annual Revenue</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="mdi mdi-currency-usd"></i>
						</span>
						<input class="form-control" formControlName="annualRevenue" placeholder="Annual Revenue" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Plan Asset Size</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="mdi mdi-currency-usd"></i>
						</span>
						<input class="form-control" formControlName="planAssetSize" placeholder="Plan Asset Size" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Plan Participants</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="ri-team-fill"></i>
						</span>
						<input class="form-control" formControlName="planParticipants" placeholder="Plan Participants" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Provider/Carrier 1</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-bank"></i>
						</span>
						<input class="form-control" formControlName="providerCarrier1" placeholder="Provider/Carrier 1" />
					</div>
				</div>
				<div class="col-md-2">
					<label>Renewal Month</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-calendar"></i>
						</span>
						<select class="form-control" formControlName="renewalMonth" placeholder="Renewal Month">
							<option value="01">January</option>
							<option value="02">February</option>
							<option value="03">March</option>
							<option value="04">April</option>
							<option value="05">May</option>
							<option value="06">June</option>
							<option value="07">July</option>
							<option value="08">August</option>
							<option value="09">September</option>
							<option value="10">October</option>
							<option value="11">November</option>
							<option value="12">December</option>
						</select>
					</div>
				</div>
				<div class="col-md-1">
					<label>Year</label>
					<select class="form-control" formControlName="renewalYear">
						<option *ngFor="let year of years" [value]="year">
							{{ year }}
						</option>
					</select>
				</div>
				<div class="col-md-3">
					<label>Provider/Carrier 2</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-bank"></i>
						</span>
						<input class="form-control" formControlName="providerCarrier2" placeholder="Provider/Carrier 2" />
					</div>
				</div>
				<div class="col-md-2">
					<label>Renewal Month</label>
					<div class="input-group">
						<span class="input-group-text">
							<i class="bx bxs-calendar"></i>
						</span>
						<select class="form-control" formControlName="renewalMonth2" placeholder="Renewal Month">
							<option value="01">January</option>
							<option value="02">February</option>
							<option value="03">March</option>
							<option value="04">April</option>
							<option value="05">May</option>
							<option value="06">June</option>
							<option value="07">July</option>
							<option value="08">August</option>
							<option value="09">September</option>
							<option value="10">October</option>
							<option value="11">November</option>
							<option value="12">December</option>
						</select>
					</div>
				</div>
				<div class="col-md-1">
					<label>Year</label>
					<select class="form-control" formControlName="renewalYear2">
						<option *ngFor="let year of years" [value]="year">
							{{ year }}
						</option>
					</select>
				</div>
			</div>
			<div class="row mt-2">
				<div class="col-12">
					<label>Notes</label>
					<textarea class="form-control bg-success-subtle border-success-subtle text-dark" formControlName="notes"></textarea>
				</div>
			</div>
		</div>
	</form>
</div>
<!-- LEADS -->
<div class="container mt-2" *ngIf="showCalendar === 'leads'">
	<h4>📋 Leads</h4>
	<div *ngIf="dispoTimeline?.length > 0; else noHistory">
		<div class="card mb-2" *ngFor="let dispo of dispoTimeline">
			<div class="card-body py-2">
				<h6 class="card-title mb-1">
					<span class="dispo-log-code text-danger fw-bold">
						{{ dispo.dispo }}
					</span>
					-
					{{ dispo.campaign_name }}
					-
					{{ dispo.user_login }}
					-
					<span class="text-muted">
						{{ dispo.date | date: "medium" }}
					</span>
				</h6>

				<p class="card-text small mb-0">
					{{ dispo.notes }}
				</p>
			</div>
		</div>
	</div>

	<ng-template #noHistory>
		<p class="text-muted fst-italic">No disposition history available.</p>
	</ng-template>
</div>

<app-calendar [hidden]="showCalendar !== 'callsheet'" [showCalendar]="false" [campaign_id]="campaignId" [alias]="campaignAlias" [isPadre]="true"> </app-calendar>
